export const PrimeLogo = ({
  width = '1080',
  height = '318',
  withText = true,
  className,
}: {
  width: string;
  height: string;
  withText?: boolean;
  className?: string;
}) => {
  const svgHeight = !height ? (withText ? '318' : '318') : height;
  const svgWidth = !width ? (withText ? '1080' : '370') : width;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={svgWidth}
      height={svgHeight}
      className={className}
      viewBox={withText ? '0 0 1080 318' : '0 0 370 318'}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M278.371 11.0223L357.421 147.945C361.469 154.958 361.469 162.977 357.425 169.984L278.371 306.912C274.324 313.92 267.375 317.93 259.283 317.93H101.171C93.0831 317.93 86.135 313.92 82.0869 306.912L73.9735 292.85L87.7339 268.255C88.916 266.146 91.0123 264.942 93.4318 264.942H232.932C238.328 264.942 242.959 262.268 245.655 257.594L298.357 166.315C301.057 161.637 301.057 156.292 298.357 151.619L245.655 60.3361C242.954 55.6628 238.328 52.9882 232.932 52.9882H127.527H127.411H57.8573L82.0869 11.0223C86.135 4.01516 93.0831 0.000475071 101.171 0.000475071H259.283C267.375 0.000475071 274.324 4.01516 278.371 11.0223ZM32.7562 221.467L3.03293 169.984C-1.01098 162.977 -1.01098 154.958 3.03293 147.945L27.2624 105.98H202.52H206.58H206.636C206.721 105.98 206.793 105.98 206.882 105.98C209.447 106.077 211.644 107.4 212.942 109.65L239.293 155.293C240.641 157.628 240.637 160.303 239.293 162.636L212.822 208.638C211.483 210.977 209.161 212.312 206.466 212.312H202.405V212.32L131.983 212.329C129.543 212.329 127.442 211.138 126.221 209.025C124.997 206.916 124.997 204.497 126.217 202.387L145.522 169.036C146.738 166.932 146.742 164.516 145.526 162.411C144.315 160.303 142.227 159.095 139.791 159.095H72.6127C70.1805 159.095 68.0884 160.298 66.8765 162.404L32.7562 221.467Z"
        fill="#0088D5"
      />
      {withText && (
        <path
          d="M500.25 106.163H413.283V212.342H439.095V174.799H499.225C526.21 174.799 540.29 162.918 540.29 140.921C540.29 120.242 524.45 106.163 500.25 106.163ZM497.465 154.413H439.095V126.549H497.32C508.61 126.549 514.771 131.68 514.771 140.776C514.771 149.137 508.316 154.413 497.465 154.413ZM688.565 212.342L661.577 172.894C677.565 168.493 685.776 157.641 685.776 140.921C685.776 120.242 669.937 106.163 645.737 106.163H558.77V212.342H584.581V174.799H633.418L659.528 212.342H688.565ZM642.952 154.413H584.581V126.549H642.807C653.804 126.549 660.259 132.119 660.259 140.185C660.259 148.987 653.953 154.413 642.952 154.413ZM739.014 212.342V106.163H713.203V212.342H739.014ZM926.739 212.342V106.163H896.528L849.889 162.479L803.254 106.163H773.041V212.342H798.853V136.962H799.29L849.889 197.824L900.486 136.962H900.929V212.342H926.739ZM1080 212.342V191.96H986.577V168.642H1048.61V148.252H986.577V126.549H1075.89V106.163H960.766V212.342H1080Z"
          fill="#383E42"
        />
      )}
    </svg>
  );
};
